import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('flexUiExit', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/flex-ui/exit/flex-ui-exit.html'),
        bindings: {
            destinationState: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/flex-ui/exit/flex-ui-exit.component.ts